// Barra sticky de ATC del PDP.
//
// (1) Visibilidad — IntersectionObserver sobre el CTA principal
//     ([data-the90s-main-atc]). Al salir de vista muestra la barra, al volver
//     la oculta.
//
// (2) Patrón puppet (2026-09-23) — el botón de la barra NO hace su propio
//     submit. Al pulsarlo dispara .click() sobre el CTA principal. Consecuencia:
//     reutilizamos toda la lógica del CTA (validación de cantidad, error del
//     server, refresh cart, evento shopify:cart:lines-update, scrollIntoView
//     al mensaje de error). Antes teníamos un <product-form-component> dentro
//     del sticky con su propio add: el error se perdía porque el sticky no
//     incluye <span ref="addToCartTextError">. Delegando en el principal, el
//     error se pinta arriba (donde vive el ref) y el scrollIntoView del
//     product-form.js sube al usuario para verlo.
//
// (3) Drawer abierto — cuando cualquier <theme-drawer> (cart, header search,
//     etc.) está abierto, se marca [data-drawer-open] en las barras para que
//     el CSS las oculte. Interactuar con la barra tapa los chips de pago del
//     cart drawer y no tiene sentido añadir mientras miras el carrito.

const bars = document.querySelectorAll('[data-the90s-sticky-atc]');

if (bars.length > 0) {
  const mainAtc = document.querySelector('[data-the90s-main-atc]');

  if (mainAtc) {
    // Publica la altura real de la barra como CSS var --dondy-bottom (2026-09-23).
    // Se lee del getBoundingClientRect (incluye padding y safe-area iOS que ya
    // aplica el propio sticky vía env(safe-area-inset-bottom)). El CSS defensivo
    // del block la usa para poner el bottom del botón de WhatsApp exactamente
    // encima del sticky con 12px de aire. Antes usábamos `bottom: 96px !important`
    // fijo, sobre-estimaba en muchos casos y Dondy quedaba flotando descolgado.
    // 12px de margen: mínimo suficiente para que se lea "encima de" y no "pegado".
    const publishDondyBottom = () => {
      const bar = bars[0];
      if (!bar) return;
      const h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) document.body.style.setProperty('--dondy-bottom', `${h + 12}px`);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const shouldShow = !entry.isIntersecting;
        for (const bar of bars) {
          bar.setAttribute('data-visible', shouldShow ? 'true' : 'false');
        }
        // Flag global para que el botón flotante de Dondy WhatsApp suba y no
        // quede tapado por el sticky. CSS defensivo en el propio block del
        // sticky. Usamos `bottom !important` (no transform) para no romper la
        // animación de apertura del chat de Dondy, que sí usa transform.
        document.body.toggleAttribute('data-sticky-atc-visible', shouldShow);
        if (shouldShow) publishDondyBottom();
      },
      // rootMargin 0px: la barra aparece cuando el CTA sale COMPLETAMENTE del viewport.
      { rootMargin: '0px' }
    );
    observer.observe(mainAtc);

    // Recalcula si cambia el viewport (rotación móvil, DevTools, redimensión).
    // Passive por ser un handler de scroll/resize.
    window.addEventListener('resize', publishDondyBottom, { passive: true });

    // Puppet: click en el trigger del sticky → click en el CTA principal.
    for (const bar of bars) {
      const trigger = bar.querySelector('[data-the90s-sticky-atc-trigger]');
      if (!trigger) continue;
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        // Re-consulta cada vez por si el CTA principal se re-renderizó
        // (variant change, morph). Fallback al mainAtc capturado al init.
        const target = document.querySelector('[data-the90s-main-atc]') || mainAtc;
        target?.click();
      });
    }
  }

  const updateDrawerFlag = () => {
    const anyOpen = document.querySelector('theme-drawer[open]');
    for (const bar of bars) {
      bar.toggleAttribute('data-drawer-open', !!anyOpen);
    }
  };
  document.addEventListener('theme-drawer:open', updateDrawerFlag);
  document.addEventListener('theme-drawer:close', updateDrawerFlag);
  updateDrawerFlag();
}
